var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrivingVehicle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "w-10 h-10 animate-pulse",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 13h1.18a3 3 0 0 1 5.64 0h4.36a3 3 0 0 1 5.64 0H21a1 1 0 0 1 0 2h-1.18a3 3 0 0 1-5.64 0h-4.36a3 3 0 0 1-5.64 0H3a1 1 0 0 1 0-2Zm4 3a1 1 0 1 0 1 1 1 1 0 0 0-1-1Zm10 0a1 1 0 1 0 1 1 1 1 0 0 0-1-1Zm-9-7h10a1 1 0 0 0 .95-.68l1.26-3.51A1 1 0 0 0 19 4H5a1 1 0 0 0-.95 1.32l1.26 3.51A1 1 0 0 0 7 10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrivingVehicle);
export default __webpack_public_path__ + "static/media/driving-vehicle.4d6b0c2c8f223ef182feb85b655abf91.svg";
export { ForwardRef as ReactComponent };